export default "__VITE_ASSET__DgbPogRv__"